import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq, axiosReq2 } from "../../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
const AddModalExamUser = ({ setShowModal, title, buttonName, setRecheck, reCheck, data, setSettingModal, setData, exams, userId }) => {
    let navigate = useNavigate();
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
    const [error, setEroor] = useState();


    const [allValues, setAllValues] = useState({
        // IsSelected: data ? data.isSelected : false,
        Title: data ? data.title : '',


    });
    const [allValuesError, setAllValuesError] = useState({
        Title: false,


    });
    const blurHandler = e => {
        if (e.target) {
            if (e.target.value == "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: true })
            }


        }

    }
    const changeHandler = e => {
        if (e.target) {
            if (e.target.value != "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: false })
            }
            else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })

            }
            // setAllValuesError({ ...allValuesError, [""]: false })


            setAllValues({ ...allValues, [e.target.name]: e.target.value })
        }
    }
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            addAdmin();
        }
    };


    const addAdmin = async () => {

        setSnipper(true)


        // var res = allFull(allValues)
        // console.log(res)
        if (selectedOptions) {
            const dataUser = await axiosReq("exam/InsertExamUser", "post", {
                // IsSelected: allValues?.IsSelected,
                ExamId: selectedOptions.value,
                UserId: userId

            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {

                setRecheck(!reCheck)
                setShowModal(false)
                alert("موفقیت آمیز");


            }
            else {
                console.log(allValuesError)
                setEroor(dataUser?.data)

                setShowErrorModalStep1(true);
            }
        }
        else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);


        }
    }
    const editAdmin = async () => {

        // setSnipper(true)
        // var res = allFull(allValues)
        // console.log(res)
        if (selectedOptions) {
            const dataUser = await axiosReq("exam/UpdateExam", "put", {
                ExamId: data?.examId,
                //  IsSelected: allValues?.IsSelected,
                Title: allValues?.Title,


            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)

                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");
                setShowModal(false)
            }
            else {
                console.log(allValuesError)
                setEroor(dataUser.data);

                setShowErrorModalStep1(true);
            }
        }
        else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);

        }
    }
    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            if (obj[o] == "" && o != "IsAdmin") {
                updatedState[o] = true;


                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
            // else if(obj[o] == "" && o=="SubCategoryId" && obj["CategoryId"] != ""){
            //     updatedState[o] = true;


            //     setAllValuesError({ ...allValuesError, ...updatedState })
            //     result = false;
            // }

        }
        console.log(allValuesError)
        return result
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    const [selectedOptions, setSelectedOptions] = useState([]);
    const handleSelectChange = (selected) => {
        setSelectedOptions(selected || []);
    };
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderColor: state.isFocused ? "#f1f5ff" : "#f1f5ff",
            borderRadius: 5, // رنگ بوردر در حالت فوکوس و غیرفوکوس
            "&:hover": {
                borderColor: "#f1f5ff", // رنگ بوردر هنگام هاور
            },
            boxShadow: state.isFocused ? "none" : "none", // سایه در حالت فوکوس
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#e8eeff", // رنگ پس‌زمینه تگ‌های انتخاب شده
            color: "#fff",
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: "#000", // رنگ متن تگ‌های انتخاب شده
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: "#000",
            "&:hover": {
                backgroundColor: "#E64A19", // رنگ پس‌زمینه دکمه حذف هنگام هاور
                color: "white",
            },
        }),
    };
    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[30%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>
                        <div className=" w-full mt-[23px] mb-[43px]">
                            {/* <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام</span>
                                <input
                                    onChange={changeHandler}
                                    onBlur={blurHandler}
                                    name="Title"
                                    placeholder="عنوان را اینجا بنویسید"
                                    value={allValues?.Title}
                                    onInput={maxLengthCheck}
                                    maxLength={300}
                                    // onKeyPress={(event) => {
                                    //     if (/[0-9]/.test(event.key)) {
                                    //         event.preventDefault();
                                    //     }
                                    //     if (/[۱-۹]/.test(event.key)) {
                                    //         event.preventDefault();
                                    //     }
                                    // }}
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" />
                                {
                                    allValuesError.Title ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div> */}


                            <div className="w-full">
                                <Select
                                    options={exams}
                                    // isMulti
                                    value={selectedOptions}
                                    onChange={handleSelectChange}
                                    placeholder=" انتخاب کنید"
                                    styles={customStyles}
                                    className="text-[12px] font-IRANYekanNormal focus:outline-lightGray border-[1px] border-borderGray rounded-[5px]"
                                />
                                {
                                    selectedOptions.length == 0 ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs mt-1 ml-1">
                                            لطفا فیلد را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>



                        </div>
                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                            <button onClick={() => title == "ویرایش" ? editAdmin() : addAdmin()} className="h-[40px] w-[107px] bg-Orange2 rounded-[10px]"><p className="text-[15px] text-white font-IRANYekanBold">{buttonName}</p></button>
                        </div>
                    </div>
                </div>
                {showErrorModalStep1 ?
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-[30%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold   text-red">
                                            درخواست اشتباه !
                                        </span>

                                    </div>

                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm   leading-relaxed">
                                            {error}
                                        </p>
                                    </div>

                                    <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                                        <Link

                                            className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow  bg-Orange2 font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            فهمیدم
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

                    </>
                    : null
                }
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default AddModalExamUser;